export enum Types {
	RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_REQUEST = '@atendimento/RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_INTEGRADOR_REQUEST',
	RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_SUCCESS = '@atendimento/RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_INTEGRADOR_SUCCESS',
	RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_FAILURE = '@atendimento/RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_INTEGRADOR_FAILURE',
	RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_CLEAR = '@atendimento/RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_INTEGRADOR_CLEAR',
}

export interface RecuperarAtendimentoIntegradorPPT {
	status: number;
	data: RecuperarAtendimentoIntegradorPPTData | null;
	messageError: string[] | null;
}

export interface RecuperarAtendimentoIntegradorPPTData {
	cpf: string;
	cpfCidadao: string;
	estadoUsuario: string;
	idPonto: number;
	nomePonto: string;
	estadoPonto: string;
	idAtendimento: string;
	idCidadao: string;
}

export interface RecuperarAtendimentoIntegradorPPTRequest {
	cpf: string;
}
